export default class Startup {
    public static logLaunch() {
        localStorage.setItem('mv_launch_count',
            (parseInt(localStorage.getItem('mv_launch_count') || '0', 10) + 1).toString());
    }

    public static shouldShowAds(): boolean {
        return localStorage.getItem('show_ads') !== 'false';
    }
}
